/**
 * Допустимые форматы телефона
 */

export const phoneRegExp = RegExp("^((\\+79))?(\(\\?\d{3}\)?[\- ]?\\)?[\\d\\- ]{9}$)");
